module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/2@2x_34295e75cdb6a30d0226dece494a3405.png";